//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willChange_deviceManagement_device from './willChange_deviceManagement_device';
export const willChange_deviceManagement_device = _willChange_deviceManagement_device;
export default {willChange_deviceManagement_device};

